import React from "react";
import { Utils } from "@react-awesome-query-builder/ui";
import { Button, ButtonGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
var uuid = Utils.uuid;
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    labelYes = props.labelYes,
    labelNo = props.labelNo,
    readonly = props.readonly;
  var onRadioChange = function onRadioChange(e) {
    return setValue(e.target.value == "true");
  };
  var id = uuid(),
    id2 = uuid();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    id: id,
    value: true,
    checked: !!value,
    disabled: readonly,
    color: value === true ? "success" : "secondary",
    onClick: onRadioChange,
    size: "sm"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck
  })), /*#__PURE__*/React.createElement(Button, {
    id: id2,
    value: false,
    checked: !value,
    disabled: readonly,
    color: value === false ? "danger" : "secondary",
    onClick: onRadioChange,
    size: "sm"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes
  }))));
});